export enum NetworkPerksPages {
  ReferADrivingInstuctor = "refer-a-driving-instructor",
  PassPictureBonus = "pass-picture-bonus",
  FebruaryBonus = "february-bonus",
}
